import { styled, Column, Row } from 'shared/Houston';

export const ColumnWithoutSpacing = styled(Column)`
  && {
    padding-top: 0;
  }
`;

export const PageHeader = styled(Row)`
  gap: ${({ theme }) => `${theme.spacing.stack.xxxs} 0`};
`;

export const EmptyStateContainer = styled.div`
  margin-top: 20%;
`;
